import React, { useState } from "react";
import Select, { components } from "react-select";
import { Styles } from "./styles";
import { SlArrowDown } from "react-icons/sl";
import { MultiValue } from "./multiValue";

const CustomSelect = ({ fieldItem, validateOnChange }) => {
  const {
    value,
    setValue,
    propWidth = null,
    className,
    isMulti,
    isDisabled,
    loading,
    placeholder,
    options,
    name,
    errorMessage,
    backgroundColor,
    multiValueProps = {},
    boldText = false,
    borderColor = null,
  } = fieldItem;
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border:
        "1px solid",
      borderColor:
        errorMessage && validateOnChange
          ? "var(--danger)"
          : borderColor
            ? borderColor
            : state.isFocused
              ? "var(--main-color)"
              : "#e0e0e0",
      borderRadius: "5px",
      boxShadow: state.isFocused
        ? "0 0 0 3px rgba(28, 55, 65, 0.1)"
        : "none",
      cursor: "pointer",
      background: backgroundColor ? `${backgroundColor} !important` : "white",
      color: "#000",
      minHeight: "40px !important",
      height: "40px !important",
      justifyContent: "flex-start",
      width: "100% !important",
      "&:hover": {
        borderColor: "var(--main-color)",
      },
    }),

    placeholder: (provided) => ({
      ...provided,
      textAlign: "start",
      margin: 0,
      lineHeight: "1.2",
      fontSize: "var(--font-size-small)",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      flexDirection: "row-reverse",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      paddingInlineEnd: "0 8px",
      color: "var(--main-color)",
    }),

    valueContainer: (provided) => ({
      ...provided,
      height: "40px",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
    }),

    singleValue: (provided) => ({
      ...provided,
      textAlign: "start",
      color: "#000",
      margin: 0,
      lineHeight: "1.2",
      fontWeight: boldText ? "600" : "normal",
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      backgroundColor: "transparent !important",
      color: "#000",
      height: "40px",
    }),

    menu: (provided) => ({
      ...provided,
      textAlign: "start",
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "var(--input-bg)" : "transparent",
      color: state.isSelected ? "black" : "black",
      fontWeight: boldText ? "600" : "normal",
      "&:hover": {
        backgroundColor: "var(--light-blue)",
        color: "var(--main-color)",
        fontWeight: boldText ? "600" : "normal",
      },
    }),
  };

  // Custom DropdownIndicator
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <SlArrowDown />
      </components.DropdownIndicator>
    );
  };

  return (
    <Styles className={className} propWidth={propWidth}>
      <Select
        styles={customStyles}
        isLoading={loading}
        isMulti={isMulti}
        className="select"
        defaultValue={value}
        value={value}
        isClearable
        isDisabled={loading || isDisabled}
        placeholder={placeholder || ""}
        onChange={(e) => setValue(e, name)}
        options={options}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        components={{
          DropdownIndicator,
          MultiValue: (props) => <MultiValue {...props} {...multiValueProps} />,
        }}
      />
    </Styles>
  );
};

export default CustomSelect;
